import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonItem, IonLabel, PopoverController } from '@ionic/angular/standalone';
import { isEqual } from 'lodash-es';

import { LOGGER } from '../../hgm-setup/src/module/util/logger';
import { DataProvider, Signal } from '../../providers/data-provider';
import { SignalGroupProvider } from '../../providers/signal-group-provider';

@Component({
    template: `
        @for (signal of signals; track signal[0]) {
            <ion-item button (click)="addSignal(signal)">
                <ion-label>{{ signal[1].name }}</ion-label>
            </ion-item>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonItem, IonLabel],
})
export class AddSignalComponent {
    private savedSignals: [string, Signal][] = [];

    private readonly dataProvider = inject(DataProvider);
    private readonly popoverCtrlr = inject(PopoverController);
    private readonly signalGroupProvider = inject(SignalGroupProvider);
    private readonly logger = inject(LOGGER);

    get signals() {
        const data = this.dataProvider.data();
        if (!data) {
            this.logger.error('Could not get data from provider');
            return [];
        }
        const currentSignals = Object.entries(data.signals);
        if (!isEqual(this.savedSignals, currentSignals)) {
            this.savedSignals = currentSignals;
        }
        return this.savedSignals;
    }

    async addSignal(signal: [string, Signal]) {
        const newLayout = this.signalGroupProvider.layout.slice();
        newLayout.unshift({
            type: 'signal',
            key: signal[0],
            name: signal[1].name,
            slot: signal[1].slot,
        });
        this.signalGroupProvider.layout = newLayout;
        await this.popoverCtrlr.dismiss();
    }
}
